module.exports = __webpack_public_path__ + "static/media/addKeywordIcon.3eaedfcd.svg";